import React from 'react';

interface CmsRichTextData {
  body?: string;
  background_color?: string;
}

interface CmsRichTextProps {
  data: CmsRichTextData;
}

export const CmsRichText: React.FC<CmsRichTextProps> = ({ data }) => {
  if (!data.body) {
    return null;
  }

  return (
    <div
      className="flex justify-center items-center py-300 px-50 w-full"
      style={{ backgroundColor: data.background_color ?? 'transparent' }}
    >
      <div
        className="w-full text-center uppercase font-extrabold [&>p]:m-0"
        style={{
          maxWidth: '1114px',
          color: '#34363B',
          fontSize: '45px',
          lineHeight: '44px',
          fontFeatureSettings: "'liga' off, 'clig' off",
        }}
        dangerouslySetInnerHTML={{ __html: data.body }}
      />
    </div>
  );
};

export default CmsRichText;
